export default "__VITE_ASSET__ytfJkK2j__"